<template>
  <footer class="footer">
    <div class="p-3">
      <div class="row">
        <div class="col-12 text-center col-lg-8 text-lg-left">
          <p class="m-0">
            &copy; {{ $moment().format('YYYY') }} Carrier Corporation.
            Information provided on this website is for Carrier distributors and dealers only.
            Third-party trademarks are the property of their respective owners.
            <br />
            <a :href="termsUrl" @click="openNewWindow(termsUrl)">Terms of Use</a>
            <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
            <a :href="privacyUrl" @click="openNewWindow(privacyUrl)">Privacy Notice</a>
          </p>
        </div>
        <div class="col-12 text-center col-lg-4 text-lg-right">
          <p v-if="!$root.isLoggedIn" class="m-0">
            For help and support, contact us at
            <a :href="`mailto:${contactEmail}`">
              <strong>{{ contactEmail }}</strong>
            </a>
          </p>
          <p v-else class="m-0">
            For help and support, fill out our
            <a
              class="ga-event"
              data-ga-category="Buttons"
              data-ga-action="feedback-form"
              data-ga-label="Feedback Form"
              href="#"
              @click.prevent="showContactModal()"
            >
              <strong>Feedback Form</strong>
            </a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import ContactModal from "components/layout/partials/ContactModal";
export default {
  components: { ContactModal },
  props: {
    termsUrl: { type: String },
    privacyUrl: { type: String },
    contactEmail: { type: String }
  },
  methods: {
    showContactModal() {
      this.$modal(ContactModal)
        .then(() => {})
        .catch(() => {});
    },
    openNewWindow(url) {
      event.preventDefault();
      window.open(url, "newwindow", "width=800,height=600");
      return false;
    }
  }
};
</script>
